import { useQuery } from '@tanstack/react-query'
import { pipe, path, map, values, filter } from 'ramda'
import client from '@/ports/api-client'

type Timeline = {
  listing_id: string
  last_read: string
  room_metadata: string | null
  is_read: string
  is_favourite: string
  last_event: string
  timeline_room: string
  state_machine: string
  units: {
    id: string
    unit_number: string
    hide_unit_number: string
  }
  listings: {
    id: string
    state_machine: string
    listing_tenants: string[]
  }
  applications: {
    id: string
    user_id: string
  }
  buildings: {
    id: string
    building_type_txt_id: string
    name: string
    street_number: string
    street_name: string
    full_street_name: string
    city: string
    state: string
    country_code: string
    zip: string
    neighborhood: string | null
    full_address: string
    geo_address: string
    lat: string
    lng: string
  }
  user_ids: {
    them: string[]
    us: string[]
  }
  primary_user_ids: {
    them: string
    us: string
  }
}

const mapApplications = pipe(values, map(path(['applications', 'id'])), filter(Boolean))

const getListingTimelines = async (listingId: string) => {
  return (await client.get(`/timeline/listings/${listingId}`)) as Record<string, Timeline>
}

const useGetListingApplications = (listingId: string) => {
  return useQuery({
    queryKey: ['applications', listingId],
    queryFn: () => getListingTimelines(listingId).then(data => mapApplications(data.timelines)),
    refetchOnWindowFocus: false,
    enabled: !!listingId
  })
}

export default useGetListingApplications
